import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { credentials } from '@shootsta/client-auth';


function skipComponent(queryParams) {
  const { auth, user } = credentials.get();
  const { isAnonymous } = user || {};

  const parsed = queryString.parse(queryParams);

  return !auth && parsed.p || auth && isAnonymous;
}

function withPublicLink(Component) {
  return withRouter((props) => {
    const { location, children } = props;

    if (skipComponent(location.search)) {return children;}

    return <Component {...props}>{children}</Component>;
  });
}

export default withPublicLink;